module.exports = __webpack_public_path__ + "img/ic-blokk.38b25b72.svg";